<script>
    import AuthService from '../../app-front/services/api/AuthService';

    export default {
        name: "Auth",
        data(){
            return {
                authTokenName: 'at',
                authTokenPrefix: 'Bearer ',
                beforeLoginPathName: 'blp',
                loginUrl: '/login',
            }
        },
        computed: {
            isUserLoggedIn() {
                return this.$store.getters.isLogged;
            },
            isAuthChecked() {
                return this.$store.getters.account.isAuthChecked;
            }
        },
        methods: {
            authFailActionHandle() {
                /*override in used component / mixin for handling failed auth*/
                this.redirectToLogin();
            },
            authFailRouteHandle() {
                /*override in used component / mixin for handling failed auth*/
            },
            authSuccessActionHandle() {
                /*override in used component / mixin for handling success auth*/
            },
            authSuccessRouteHandle() {
                /*override in used component / mixin for handling success auth*/
            },
            checkAuth() {
                if(this.isUserLoggedIn) {
                    this.authSuccessActionHandle();
                    this.authSuccessRouteHandle();

                    return true;
                }

                const token = window.authToken || this.getAuthToken();

                if(token) {
                    AuthService.checkAuthToken(token)
                        .then(res => {
                            this.setAuthToken(token);
                            this.initLogin(token);
                            this.resetWindowAuthToken();
                            this.authSuccessRouteHandle();
                        })
                        .catch(err => {
                            this.authFailRouteHandle();
                        }).finally(() => {
                            this.$store.commit('setAuthChecked', true);
                        });
                } else {
                    this.authFailRouteHandle();
                    this.$store.commit('setAuthChecked', true);
                }
            },
            initLogin(token) {
                this.setAuthToken(token);
                this.$store.commit('updateLoggedIn', true);
                this.$store.commit('updateIsAuthPending', false);
            },
            initLogout() {
                this.resetAuthToken();
                this.$store.commit('updateLoggedIn', false);
                this.$store.commit('setBasket', []);
                this.$store.commit('setFavorites', []);
            },
            getAuthToken(){
                return AuthService.getAuthToken();
            },
            getBeforeLoginPath() {
                return localStorage.getItem(this.beforeLoginPathName);
            },
            logout(){
                AuthService.logout().then(res => {
                    this.initLogout();
                });
            },
            loginRedirect() {
                const path = this.getBeforeLoginPath();

                if(path) {
                    this.$router.push(path).then(() => {
                        this.resetBeforeLoginPath();
                    });
                }
            },
            redirectForLoginWithPath(path) {
                this.setBeforeLoginPath(path);
                console.log(this.getBeforeLoginPath());
                this.$router.push(this.loginUrl).then(() => {});
            },
            resetAuthToken() {
                localStorage.setItem(this.authTokenName, '');
            },
            resetBeforeLoginPath() {
                localStorage.setItem(this.beforeLoginPathName, '');
            },
            resetWindowAuthToken() {
                if(window.authToken) {
                    delete(window.authToken);
                }
            },
            setAuthToken(token){
                localStorage.setItem(this.authTokenName, token);
            },
            setBeforeLoginPath(path) {
                this.$store.commit('updateBeforeLoginPath', path);
                localStorage.setItem(this.beforeLoginPathName, path);
            }
        },
    }
</script>

<style scoped>

</style>
